/**
 * Wayfinding cue shown at the top of the Parameters tab for non-Native agent
 * variants. Points authors at the Harness tab where variant-specific platform
 * config lives (sandbox for Coding, project + model for Foundry, hosted-agent
 * info + tools for Hosted).
 *
 * The copy is intentionally variant-agnostic: "environment settings" reads
 * correctly for all three variants without leaking variant-specific wording
 * ("sandbox", "project", "hosted agent") into a Parameters-tab surface.
 *
 * The Harness word is a Fluent Link that fires the caller-supplied
 * `onNavigate` — the drawer wires it to `goToSection('harness')`, the legacy
 * ExpandedView wires it to `setActiveTab('agent-harness')`. When
 * `onNavigate` is absent (defensive), the link renders inert.
 */
import { makeStyles, tokens, MessageBar, MessageBarBody, Link } from '@coreai/fluentui-react';

const useStyles = makeStyles({
  wrapper: {
    marginBottom: tokens.spacingVerticalS,
  },
});

interface HarnessTabHintProps {
  onNavigate?: (() => void) | undefined;
}

export const HarnessTabHint = ({ onNavigate }: HarnessTabHintProps) => {
  const styles = useStyles();
  return (
    <div className={styles.wrapper}>
      <MessageBar intent="info" layout="singleline">
        <MessageBarBody>
          Configure environment settings in the{' '}
          <Link as="button" onClick={onNavigate} disabled={!onNavigate}>
            Harness
          </Link>{' '}
          tab.
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};
